export default function(
  state = { languages: [], documentTypes: [], documentCategories: [] },
  action
) {
  switch (action.type) {
    case "SET_LANGUAGES":
      return Object.assign({}, state, {
        languages: action.languages,
      });
    case "SET_DOCUMENT_TYPES":
      return Object.assign({}, state, {
        documentTypes: action.documentTypes,
      });
    case "SET_DOCUMENT_CATEGORIES":
      return Object.assign({}, state, {
        documentCategories: action.documentCategories.sort((a, b) => {
          if (a.groupName == null) {
            if (b.groupName == null) {
              return 0;
            } else {
              return 1;
            }
          } else {
            if (b.groupName == null) {
              return -1;
            } else {
              return (
                a.groupName.localeCompare(b.groupName) ||
                a.title.localeCompare(b.title)
              );
            }
          }
        }),
      });
    default:
      return state;
  }
}
